module.exports = __webpack_public_path__ + "static/media/Datas_DESEN._CHATBOTS_AMB._CORPORATIVOS.6a8985c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/chatbot/Datas_DESEN._CHATBOTS_AMB._CORPORATIVOS.png
// module id = 242
// module chunks = 0